export type { EntityNoticeOtpStepProps } from './entity-notice-otp-step'
export { EntityNoticeOtpStep } from './entity-notice-otp-step'
